// extracted by mini-css-extract-plugin
export default {"wrapper":"ButtonMore_wrapper__o+gRV","item":"ButtonMore_item__aaPia","icon":"ButtonMore_icon__76Nmg","menu":"ButtonMore_menu__u4e0U","button":"ButtonMore_button__-FHza"};